module.exports = __webpack_public_path__ + "img/ne_footer_logo.6b747c17.svg";